const Devices = ({ stroke = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 16 16"
  >
    <rect
      x="1.5"
      y="3"
      width="10"
      height="7"
      rx="1"
      stroke={stroke}
      strokeWidth="1.3"
    />
    <rect
      x="9.5"
      y="6"
      width="5"
      height="8"
      rx="1"
      stroke={stroke}
      strokeWidth="1.3"
    />
    <path d="M3 12h5" stroke={stroke} strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

export default Devices;
